enum LogisticsListKeys {
  LOGISTIC_ID = 'logistic-id',
  LOGISTIC_NAME = 'logistic-name',
  LOGISTIC_TYPE = 'logistic-type',
  LOGISTIC_CATEGORY = 'logistic-category',
  LOGISTIC_STATUS = 'logistic-status',
  LOGISTIC_LOCATION = 'logistic-location',
  LOGISTIC_EQUIPMENT = 'logistic-equipment',
  LOGISTIC_COMPANY = 'logistic-company',
  LOGISTIC_DATE = 'logistic-date',
  LOGISTIC_START_DATE = 'logistic-start-date',
  LOGISTIC_END_DATE = 'logistic-end-date',
  LOGISTIC_RESPONSIBLE = 'logistic-responsible',
  LOGISTIC_ATTACHMENT = 'logistic-attachment',
  LOGISTIC_SHARED_ENTITY = 'logistic-shared-entity',
  LOGISTICS_TIMELINE = 'logistics-timeline',
}

export default LogisticsListKeys
